import * as React from 'react';
import { IInvoiceData, SelectionAreaInvoiceDataRow } from '../../../../models/IInvoice';
import { ButtonType, CustomButton, SpinnerWrapper, Table } from "soprasteria-ui-library";
import { formatCurrency } from '../../../../helpers/CurrencyHelper';
import '../../../../assets/styles/table.scss';
import { BillableTreatmentsTable } from './BillableTreatmentsTable';
import { IPatientTreatment } from '../../../../models/IPatientTreatment';
import { useAuth } from '../../../../App';
import { InvoiceApi } from '../../../../api/InvoiceApi';
import { ICareProvider } from '../../../../models/ICareProvider';


interface ICreateInvoiceInvoicesTable {
    invoices: IInvoiceData[];
    invoiceReference: string;
    selectedTreatmentType?: string;
}

export const CreateInvoiceInvoicesTable: React.FunctionComponent<ICreateInvoiceInvoicesTable> = ({ invoices, invoiceReference, selectedTreatmentType }) => {

    const auth = useAuth();
    const api = new InvoiceApi(auth);
    const [renderInvoiceRows, setRenderInvoiceRows] = React.useState<boolean>(false);
    const [isFetchingInvoiceDataRows, setIsFetchingInvoiceDataRows] = React.useState<boolean>(false);
    const [selectedInvoiceDataRows, setSelectedInvoiceDataRows] = React.useState<IPatientTreatment[] | SelectionAreaInvoiceDataRow[]>();
    const [selectedCareProviderName, setSelectedCareProviderName] = React.useState<string>();

    const getInvoiceDataRows = (treatmentTypeId: string, careProvider: ICareProvider) => {
        setIsFetchingInvoiceDataRows(true);
        setSelectedCareProviderName(careProvider.displayCareProviderName);
        api.getInvoiceDataRows(parseInt(treatmentTypeId), careProvider.careProviderId, (response) => {
            setSelectedInvoiceDataRows(response);
        }, undefined, () => {
            setIsFetchingInvoiceDataRows(false);
            setRenderInvoiceRows(true);
        })
    }

    return (
        <SpinnerWrapper isLoading={isFetchingInvoiceDataRows}>
            <div className="scrollable-table">
                {
                    renderInvoiceRows ?
                        <>
                            <h5>Fakturarader för {selectedCareProviderName}</h5>
                            <BillableTreatmentsTable invoiceDataRows={selectedInvoiceDataRows} />
                            <CustomButton buttonType={ButtonType.general} buttonText="Tillbaka" onClick={() => setRenderInvoiceRows(false)} />
                        </>
                        :
                        <>
                            <h5>Fakturor som kommer skapas upp</h5>
                            <Table hoverableRows>
                                <thead>
                                    <tr>
                                        <th style={{ width: "45%" }}>Mottagning</th>
                                        <th style={{ width: "40%" }}>Fakturareferens</th>
                                        <th className="text-right" style={{ width: "15%" }}>Summa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        invoices.map((invoice, key) =>
                                            <tr key={key} className="clickable-row">
                                                <td style={{ width: "45%" }} onClick={() => getInvoiceDataRows(selectedTreatmentType ?? "0", invoice.careProvider)}>{invoice.careProvider.displayCareProviderName}</td>
                                                <td style={{ width: "40%" }} onClick={() => getInvoiceDataRows(selectedTreatmentType ?? "0", invoice.careProvider)}>{`${invoiceReference} ${invoice.careProvider.clinicNumber ?? ""}`}</td>
                                                <td style={{ width: "15%" }} onClick={() => getInvoiceDataRows(selectedTreatmentType ?? "0", invoice.careProvider)} className="text-right">{formatCurrency(invoice.billableAmount)}</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </>
                }
            </div>
        </SpinnerWrapper>
    )
}